import "./sass/index.scss";

import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { createBrowserHistory } from "history";
import { BrowserRouter as Router } from "react-router-dom";

import createStore from "./store";
import routes from "./routes";

const history = createBrowserHistory();
const store = createStore(history);

render(
  <Provider store={store}>
    <Router history={history}>{routes}</Router>
  </Provider>,
  document.getElementById("app")
);

require.context("./public", true, /\.(png|ico|jpg|svg)$/);
